// extracted by mini-css-extract-plugin
module.exports = {"cardDashboardgeneral":"form_cardDashboardgeneral__1wV6Z"};